class PaidPeriodInfoService {

    getPeriodGridList(setData, setGridData, userId) {
        fetch("/period/gridlist")
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw "No period found!"
                }
            }).then(data => {
            // data=data[0].paidPeriodInfoList;
            setData(data);
            setGridData(data['paidPeriodInfoList']);
        }).catch(error => {
            setGridData([]);
            console.log(error);
        })
    }

    updatePeriodGridList(setData) {
        fetch("/period/gridlist", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(setData)
        }).then(res => res.json()).then(data => {
            // setData(data['paidPeriodInfoList']);
            setData(data);
        });
    }

    getPaymentTypesList(setData) {
        fetch("/period/paymenttyes")
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw "No period found!"
                }
            }).then(data => {
            setData(data);
        }).catch(error => {
            setData([]);
            console.log(error);
        })
    }
}



export default PaidPeriodInfoService;